import { render, staticRenderFns } from "./AgeingPage.vue?vue&type=template&id=19e86033&scoped=true&"
import script from "./AgeingPage.vue?vue&type=script&lang=js&"
export * from "./AgeingPage.vue?vue&type=script&lang=js&"
import style0 from "./AgeingPage.vue?vue&type=style&index=0&id=19e86033&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e86033",
  null
  
)

export default component.exports